/*
 * File: /src/router/routes/emails.js
 * Created Date: Saturday December 28th 2019
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Saturday, 28th December 2019 3:06:47 pm
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2019 AdBase, Inc.
 */
const ListEmails = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Emails/ListEmails.vue');
const AddEmail = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Emails/AddEmail.vue');

const EditEmail = () =>
  import(/* webpackChunkName: "ValidDomain" */ 'src/components/Dashboard/Views/Emails/EditEmail.vue');

export const emailRoutes = [
  {
    path: 'emails/',
    name: 'Verified Emails',
    component: ListEmails
  },
  {
    path: 'emails/add',
    name: 'Add New Email',
    component: AddEmail
  },
  {
    path: 'emails/:id',
    name: 'Edit Email',
    component: EditEmail
  }
];
